import { createFileRoute } from '@tanstack/react-router'
import { playbackParamsSchema, playbackRouteQueryOptions, playbackSearchSchema } from '../../../src/schemas/routeSchemas'

export const Route = createFileRoute('/playback/$id')({
  validateSearch: (search) => playbackSearchSchema.parse(search),
  params: {
    parse: (params) => playbackParamsSchema.parse(params),
  },
  loaderDeps: () => ({}),
  loader: async ({ context, params }) => {
    await context.queryClient.ensureQueryData(playbackRouteQueryOptions(params.id))
  },
  staticData: {
    englishAllowed: true,
  },
})
